module.exports = __webpack_public_path__ + "assets/images/couch-04.c0ec25a7cfc2e028e66f89804aee58db.svg";